import { render } from "./user-report.vue?vue&type=template&id=e2479e10"
import script from "./user-report.vue?vue&type=script&lang=js"
export * from "./user-report.vue?vue&type=script&lang=js"

import exportComponent from "/home/staging-tcms.qpax-tcms.net/public_html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__